import {styled, Typography, useTheme} from "@mui/material";
import KeyIcon from "../../assets/icons/KeyIcon";
import {BoxBodyContainer, RawBox} from "./Dashboard/styled";
import {useNavigate} from "react-router-dom";
import bankAvatar from "assets/images/bankAvatar.svg";

const StyledBoxBodyContainer = styled(BoxBodyContainer)({
    // height: '100px',
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    // backgroundImage: 'url("/assets/images/bank.svg")',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: '100% 100%',
});
const StyledRawBox = styled(RawBox)({
    justifyContent: "center",
    backgroundImage: 'url("/assets/images/bank.svg")',
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "100%",
    width: "100%",
    boxShadow: "0px 0px  10px  0px #cac6c6",
});

const UpperSection = styled("div")({
    display: "grid",
    gridTemplateColumns: "30% 65%",
    width: "280px",
    gridGap: "10px",
    height: "70px",
});
const MiddleSection = styled("div")({
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
    gridTemplateColumns: "10% 35%",

    // gridGap: '10px',
    marginTop: "20px",
});
const BankdetailsContainer = styled("div")({
    display: "grid",
    flexDirection: "column",
    justifyContent: "space-evenly",
});

const BankImageContainer = styled("div")(({theme}) => ({
    borderRadius: theme?.shape.borderRadius,
    border: `2px solid ${theme?.palette.disabled.light}`,
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

const BankCard = ({item, itemKey}: { item: any; itemKey: number }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <StyledRawBox>
            {/* <StyledBoxUpper title='بانکداری' /> */}
            <StyledBoxBodyContainer>
                <UpperSection>
                    <BankImageContainer>
                        <img alt="" src={bankAvatar}/>
                    </BankImageContainer>
                    <BankdetailsContainer style={{color: "#282929"}}>
                        <Typography fontSize={14}>{`${item?.accountingCode} - ${item?.name}`}</Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary}>
                            {item.accountNumber}
                        </Typography>
                    </BankdetailsContainer>
                </UpperSection>
                <MiddleSection>
                    <KeyIcon/>
                    <Typography textAlign="center" color={theme.palette.text.secondary}>
                        {item.branch}
                    </Typography>
                </MiddleSection>
            </StyledBoxBodyContainer>
        </StyledRawBox>
    );
};

export default BankCard;
